import styles from '../../../styles/Tokens.module.scss';

const getTokenTypeLabel = (tokenType) => {
	if (tokenType === 'open_gym') return 'Open Gym';
	if (tokenType === 'class') return 'Class';
	return 'General';
};

function Product({ _id, credits, price, description, tokenType }) {
	const tokenLabel = getTokenTypeLabel(tokenType);
	const label = description?.trim()
		? `${description}${credits > 0 ? ` (${credits} ${tokenLabel} ${credits > 1 ? "Tokens" : "Token"})` : ''}`
		: `${credits} ${tokenLabel} ${credits > 1 ? "Tokens" : "Token"}`;

	return (
		<div key={_id} className={styles.product}>
			<p><strong>{label}</strong></p>
			<a href={`/dashboard/tokens/checkout/${_id}`} className="btn btnPrimary">£{(price / 100).toFixed(2)}</a>
		</div>
	)
}

export default Product;
